import { ArchiveMarkerIcon } from './ArchiveMarkerIcon';

/**
 * author: Colton Wiscombe
 * id FDC11926-2947-4451-A7CE-2466D7CB8E07
 * name archive-marker
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-marker.svg
 * tags
 * - Navigation 
 */
export const ArchiveLocationIcon = ArchiveMarkerIcon;
export default ArchiveLocationIcon